import { Box, CircularProgress, Drawer, IconButton, Tab, Tabs, useMediaQuery, useTheme } from "@mui/material";
import { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import LinkCard from "../Components/LinkCard";
import ActionCard from "../Components/ActionCard";
import { FiX } from "react-icons/fi";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export const DeepAgentSidebar = forwardRef(({ onOpenChange }, ref) => {
  const [isDeepAgentDrawerOpen, setIsDeepAgentDrawerOpen] = useState(false);
  const [deep_agent_infos, setDeepAgentInfos] = useState({'infos': [], 'actions': [], 'references': []});
  const [value, setValue] = useState(0);
  const [loading, setLoading] = useState(true);
  const [currentDeepAgentId, setCurrentDeepAgentId] = useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('mobile'));

  useImperativeHandle(ref, () => ({
    openDrawer: () => {
      setIsDeepAgentDrawerOpen(true);
    },
    // Completely reset and set new info
    setInfos: (infos, agentId) => {
      setCurrentDeepAgentId(agentId);
      setDeepAgentInfos(infos);
      setLoading(false);
    },
    closeDrawer: () => {
      setIsDeepAgentDrawerOpen(false);
    },
    toggleDrawer: () => setIsDeepAgentDrawerOpen(prev => !prev),
    getIsOpen: () => isDeepAgentDrawerOpen,
    getCurrentAgentId: () => currentDeepAgentId
  }));

  useEffect(() => {
    if (onOpenChange) {
      onOpenChange(isDeepAgentDrawerOpen);
    }
    setValue(0); // Reset the tab to the first one when the drawer opens
    
    // When drawer closes, reset the agent ID after a short delay
    if (!isDeepAgentDrawerOpen) {
      setTimeout(() => {
        setCurrentDeepAgentId(null);
      }, 300); // Delay to match drawer close animation
    }
  }, [isDeepAgentDrawerOpen, onOpenChange]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };


  return (
    <Drawer
      anchor={'right'}
      open={isDeepAgentDrawerOpen}
      onClose={() => setIsDeepAgentDrawerOpen(false)}
      variant="persistent"
      sx={{
        '& .MuiDrawer-paper': {
          width: isMobile ? '100%' : '400px', 
          backgroundColor: theme.palette.appBackground,
        },
      }}
    >
      <div
        style={{
          width: isMobile ? '100vw' : '400px',
          padding: '1rem',
          height: '100%',
          backgroundColor: theme.palette.appBackground,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 2,
            backgroundColor: theme.palette.appBackground,
          }}
        >
          <h2 style={{ margin: 0 }}>Deep Agent</h2>
          <IconButton
            onClick={() => setIsDeepAgentDrawerOpen(false)}
            sx={{
              color: theme.palette.text.primary,
            }}
          >
            <FiX size={24} />
          </IconButton>
        </Box>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange} aria-label="Actions and Sources Tabs">
            <Tab label="Actions" {...a11yProps(0)} />
            <Tab label="Sources" {...a11yProps(1)} />
          </Tabs>
        </Box>
        {loading && (
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <CircularProgress
              size={24}
              sx={{
                color: theme.palette.primary.main,
              }}
            />
          </div>
        )}
        <Box
          role="tabpanel"
          hidden={value !== 0}
          id={`simple-tabpanel-0`}
          aria-labelledby={`simple-tab-0`}
          sx={{
            paddingY: 2,
            backgroundColor: theme.palette.appBackground,
          }}
        >
          {value === 0 && !loading && (
            <div>
              {deep_agent_infos && deep_agent_infos.actions && deep_agent_infos.actions.length > 0 && deep_agent_infos.actions.map((action) => (
                <ActionCard key={action.id} action={action} />
              ))}
            </div>
          )}
        </Box>
        <Box
          role="tabpanel"
          hidden={value !== 1}
          id={`simple-tabpanel-1`}
          aria-labelledby={`simple-tab-1`}
        >
          {value === 1 && !loading && (
            <div>
              {deep_agent_infos && deep_agent_infos.references && deep_agent_infos.references.length > 0 && deep_agent_infos.references.map((source) => (
                <LinkCard key={source.id} link={source} />
              ))}
            </div>
          )}
        </Box>
      </div>
    </Drawer>
  );
});